const currentContextKey = '__uaksnoo1871923_'

const { localStorage } = window;

export const storageProvider = {

    // CurrentContext
    setCurrentContext: (ctx) => {
        localStorage.setItem(currentContextKey, Buffer.from(JSON.stringify(ctx)));
    },
    getCurrentContext: () => {
        const content = localStorage.getItem(currentContextKey);
        try {
            return JSON.parse(content.toString());
        } catch (e) {
            return null;
        }
    },
    removeCurrentContext: () => {
        localStorage.removeItem(currentContextKey);
    },

}